import React from 'react';
import { Subtract } from 'utility-types';

import { ISanitizer, sanitize } from '../../commonInfra/utils/Sanitize';

export interface InjectedSimulationSpaceServiceInjectorProps {
  readonly sanitizer: ISanitizer;
}

export interface SimulationSpaceServiceInjectorProps {
  readonly simulationId: string;
}

export function withSimulationSpaceServiceInjector<P extends InjectedSimulationSpaceServiceInjectorProps>(
  Component: React.ComponentType<P>
) {
  return function SimulationSpaceServiceInjector(
    props: Subtract<P, InjectedSimulationSpaceServiceInjectorProps> & SimulationSpaceServiceInjectorProps
  ) {

    return <Component
      {...props as unknown as P}
      sanitizer={sanitize}
    />;
  };
}
